export interface ActiveUpcomingMeetingsResponse {
    ongoingMeetings: JitsiActiveMeetingModel[];
    upcomingMeetings: ScheduledMeetingModel[];
}

export class JitsiActiveMeetingModel {
    startedAt: number;
    elapsedTime: number;
    orgId: number;
    participants: JitsiParticipantModel[];
    room: string;
    meetingId: string;
    organiserId: number;
    title: string;
    meetingNumber: string;
    meetingProgress: string;
    isAdhoc: boolean;
    startDateTime: string;
    expectedEndDateTime: string;
}

export interface ParticipantViewModel extends JitsiParticipantModel {
    image?: string | null;
}


export class JitsiParticipantModel {
    id: string;
    name: string;
    email: string;
    userType: string;
    joinTime: number | null;
    leaveTime: number | null;
    duration: number | null;
    accountId: number;
    userId: number;
    orgId: number;
    senderUserId: string;
    meetingId: number;
    isOrganiser: boolean;
    timezone: string;
    projectId: number;
    teamId: number;
}

export class ScheduledMeetingModel {
    meetingId: number;
    meetingKey: string;     // room name
    meetingNumber: string;
    title: string;
    organizerAccountId: number;
    meetingType: string;
    venue: string;
    startDateTime: string;
    endDateTime: string;
    createdAccountId: number;
    orgId: number;
    buId: number;
    projectId: number;
    teamId: number;
    meetingProgress: string;
    isAdhoc: boolean;
}

export const JITSI_MAX_VISIBLE_ATTENDEES = 3;

export const DEFAULT_MEETING_TITLE = "Please edit_untitled_";

export const JITSI_MEETING_EXPIRY_TIMER = {
    TEN_MINUTES: 10,
    FIVE_MINUTES: 5,
    ONE_MINUTE: 1,
}

export const EXPIRY_DIALOG_RESPONSE = {
    EXIT: "exit",
    CONTINUE: "continue",
}

export const MEETING_15_MINUTES_BEFORE_ALREADY_SCHEDULED = 15;